import { request } from '../functions';
import { FETCH_ESHOP_ENUMS, CLEAN_ESHOP_ENUMS } from './types';

export const fetchEshopEnums = screen => {
    return dispatch => request('/user-eshops/eshopEnums').then(({ data }) => {
        const { user } = data.sync;
        const { setUser } = screen.props;

        setUser(user);

        dispatch({ type: FETCH_ESHOP_ENUMS, payload: data.data });
    });
};

export const cleanEshopEnums = () => ({ type: CLEAN_ESHOP_ENUMS });
